module.exports = __webpack_public_path__ + "static/media/CircularXXWeb-Italic.81580fe7.woff";